// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--aHsp2","label":"_4f720283bf--label--lcahG"};